// main
import ContentFormatXX from '../content/webz/content-format-xx';
import WebbDividerSmall from '../content/webx/webb-divider-sm';
import WebbDividerMedium from '../content/webx/webb-divider-md';

import { UserForm } from '../services/srvc-utilities';

import AccountsCreateModule from '../content/accounts/accounts-create';

export default function AccountsCreate() {
  


  return (
    <ContentFormatXX 
      head = {'Link Account'}
      home = {`/`}
      link = {`/${UserForm()}/home`}
      form = {'mini'}
      data = {
        <>
          <WebbDividerSmall />
          <AccountsCreateModule />
          
        </>
        
      }  
    /> 
  )
}